import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

const INIT_FOOTER_STATE = 'footerStateInfoAction/initFooterState';
const UPDATE_FOOTER_STATE = 'footerStateInfoAction/updateFooterState';

export const initFooterState = createAction(INIT_FOOTER_STATE);
export const updateFooterState = createAction(UPDATE_FOOTER_STATE);

const initialState = {
    visible: true
}

export default handleActions({
    [INIT_FOOTER_STATE]: (state, action) => {
        return produce(state, draft => {
            draft.visible = true
        })
    },
    [UPDATE_FOOTER_STATE]: (state, action) => {
        return produce(state, draft => {
            draft.visible = action.payload.visible
        }) 
    }
}, initialState)